import classNames from 'classnames';
import type { FC } from 'react';
import { Button } from '../Button/Button';
import type { ButtonProps } from '../Button/Button.types';

/**
 * Exception for buttons to be used in table: strip padding to fit to table row height.
 * This variant of Button shouldn't be used anywhere else.
 */
export const TableButton: FC<ButtonProps> = ({
  className,
  size,
  ...otherProps
}) => (
  <Button
    {...otherProps}
    className={classNames(className, '!p-0')}
    size={size ?? 'small'}
  />
);
